/* eslint-disable import/prefer-default-export */
export function getAPIToken(): string {
  const token = localStorage.getItem('Token');
  if (token) {
    return token;
  }

  return '';
}
